module.exports = __webpack_public_path__ + "static/media/Parking_solution.7ebfd345.png";